export enum AppConfigSectionNames {
  treatmentTypeConfig = 'TreatmentTypeConfig',
  defaultApplianceProfile = 'DefaultApplianceProfile',
}
